// extracted by mini-css-extract-plugin
module.exports = {"inputForm":"UpdatePassword_inputForm__kOzhs"};